export const KM_FOLDER_NAME = "Khanmigo Documents";
export const DEFAULT_DOCUMENT_NAME = "Khanmigo Document";
